import cancers from "./conditionsList/cancers"
import cardiovascularDiseases from "./conditionsList/cardiovascular"
import endocrine from "./conditionsList/endocrine"
import respiratory from "./conditionsList/respiratory"
import neurological from './conditionsList/neurological'
import gastro from './conditionsList/gastro'
import msk from "./conditionsList/msk"

const options = [
    { category: null, disease: 'No Past Medical History' },
    ...cardiovascularDiseases,
    ...cancers,
    ...respiratory,
    ...endocrine,
    ...neurological,
    ...gastro,
    ...msk
]

export default options
